<template>
    <div class="row justify-content-center">
        <div class="col-8">
            <div class="d-flex align-items-center">
                <div class="form-content w-100 white-content">
                    <div class="row">
                        <div class="col-6">
                            <div class="form-group">
                                <input type="text" v-model="userData.name" disabled>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <input type="text" v-model="userData.surnames" disabled>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-group">
                                <input type="text" v-model="userData.email" disabled>
                            </div>
                        </div>
                    </div>                            
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [ 'userData' ]
}
</script>
